export default {
  install(Vue) {
    Vue.filter('date', function (value, format) {
      if (value) {
        return moment(String(value)).format(format || 'DD/MM/YYYY')
      }
    });

    Vue.filter('datetime', function (value, format) {
      if (value) {
        if(!isNaN(value)){
          return moment(value).format(format || 'DD-MM-YYYY HH:mm:ss')
        }
        return moment(String(value)).format(format || 'DD-MM-YYYY HH:mm:ss')
      }
    })

  }
}